import { TYPES } from "./types";
import { tkt1NetworkModemService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1NetworkModems = (query) => async (dispatch) => {
  try {
    const result = await tkt1NetworkModemService.getNetworkModems(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_NETWORK_MODEMS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_NETWORK_MODEMS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1NetworkModemByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1NetworkModemService.getNetworkModemByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_NETWORK_MODEM_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1NetworkModem = (networkModemData) => async (dispatch) => {
  try {
    const result = await tkt1NetworkModemService.createNetworkModem(networkModemData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_NETWORK_MODEM_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_NETWORK_MODEM_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1NetworkModem = (id, networkModemData) => async (dispatch) => {
  try {
    const result = await tkt1NetworkModemService.updateNetworkModem(id, networkModemData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_NETWORK_MODEM_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_NETWORK_MODEM_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1NetworkModem = (id) => async (dispatch) => {
  try {
    const result = await tkt1NetworkModemService.deleteNetworkModem(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_NETWORK_MODEM_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_NETWORK_MODEM_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1NetworkModemAction = {
  getTKT1NetworkModems,
  getTKT1NetworkModemByID,
  createTKT1NetworkModem,
  updateTKT1NetworkModem,
  deleteTKT1NetworkModem
};
